/*
 * File: form-string.ts
 * File Created: 2024-01-11 01:28:50
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-15 04:01:46
 * Modified By: Val Liu
 * -----
 */

import { UITag } from "@root/core/tags";
import { Component, Vue } from "vue-property-decorator";

/// a pseudo element. break to a new line after this.
@UITag.setDefault({
    uiColumnSize: 12,
})
@Component
export default class FormBreak extends Vue {}
